import {
  ParamsCreateTrainingProgram,
  ParticipantTrainingProgram,
} from 'api/lms/useAPIGenerateProgram'
import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

import { useRegionContext } from 'utils/hooks/useRegion'

import { PREFIX_PELATIHAN_BCKS } from 'app/KS/KSTraining/pages/Create/constants'

export type Participant = ParticipantTrainingProgram & {
  instansi: string
  golongan?: string
  nama_dinas?: string
  domisili: string
  jabatan?: string
  user_id?: string
}

export type ProgramClass = {
  name: string
  maxParticipants: number
  admins: { email: string; name: string }[]
  instructors: Participant[]
  participants: Participant[]
}

type UseCreateProgramDraftState = {
  program: ParamsCreateTrainingProgram['program']
  classes: ProgramClass[]
}

type CreateTrainingProgramActions = {
  // modify program draft
  mutateProgramDraft: (payload: ParamsCreateTrainingProgram['program']) => void
  // add classes
  mutateClasses?: (classes: ProgramClass[]) => void
  // reset store
  reset: () => void
}

export const useCreateProgramDraft = create(
  persist<UseCreateProgramDraftState & CreateTrainingProgramActions>(
    (set, _, store) => ({
      program: {
        name: '',
        startDate: '',
        endDate: '',
        description: '',
        fundSource: undefined,
      },
      classes: [],

      mutateProgramDraft: (payload: ParamsCreateTrainingProgram['program']) =>
        set((state) => ({
          ...state,
          program: { ...state.program, ...payload },
        })),

      mutateClasses: (classes: ProgramClass[]) =>
        set((state) => ({ ...state, classes })),

      reset: () => {
        set(store.getInitialState())
      },
    }),
    {
      name: 'create-program-draft',
      storage: createJSONStorage(() => localStorage),
    }
  )
)

export const useComputedProgramName = () => {
  const program = useCreateProgramDraft((state) => state.program)

  const { regionDetail } = useRegionContext()

  return `${PREFIX_PELATIHAN_BCKS} - ${regionDetail.name} - Angkatan ${program.name}`
}
